export enum CpResponseCodes {
  OK = '100',
  CustomerAborted = '201',
  ConnectionFailure = '202',
  ServerRejected = '203',
  InternalFailure = '204',
  SessionExpired = '205',
}
